import Offcanvas from 'react-bootstrap/Offcanvas';
import 'bootstrap/dist/css/bootstrap.min.css';
import { RxCross2 } from "react-icons/rx";
import { Box, Typography } from '@mui/material';
import { IoIosArrowDown } from "react-icons/io";
import { customTextColor } from '../../utils/const';
import { useState } from 'react';
import { StylesContext } from '@mui/styles';
import styles from "./PostRequirement.module.css";
import { IoIosArrowUp } from "react-icons/io";
function SideIcon({ handleClose, side }) {

    return (
        <>
          
            <Offcanvas side={side} onHide={handleClose} placement="end" scroll={false} backdrop={false} style={{ border: "none", marginTop: "70px", width: "470px", padding: "0 0 0 10px" }}>
                <Offcanvas.Header style={{ display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>
                    {/* <Offcanvas.Title style={{ fontWeight: '600', color: customTextColor }}>Kevin Macklin - Submission History</Offcanvas.Title> */}
                    <RxCross2 style={{ fontSize: '22px', cursor: 'pointer', color: customTextColor }} onClick={handleClose} />
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Box sx={{ color: customTextColor }} className={styles.canvas_body}>
                        <span>
                            <Typography>
                                Profile Views (540)
                            </Typography>
                        </span>

                    </Box>

                    <Box sx={{ color: customTextColor }} className={styles.canvas_body}>
                        <span>
                            <Typography>
                                Phone No: 242-751-2217
                            </Typography>
                        </span>
                    </Box>

                    <Box sx={{ color: customTextColor }} className={styles.canvas_body}>
                        <span>
                            <Typography>
                                Copy E-mail
                            </Typography>
                        </span>
                    </Box>
                    <Box sx={{ color: customTextColor }} className={styles.canvas_body}>
                        <span>
                            <Typography>
                                Copy E-mail
                            </Typography>
                        </span>
                    </Box>

                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
}

export default SideIcon;